import * as React from 'react';

import { ITableConfig } from './index';
import TableHeader from './TableHeader';
import TableBody from './TableBody';

import Pager from './Pager';

import './Table.scss';
import PagedResultSet from '../../../models/common/PagedResultSet';

interface ITableProps {
    enablePaging?: boolean;
    isLoading?: boolean;
    tableConfig: ITableConfig;
    // tslint:disable-next-line
    data: PagedResultSet<any> | undefined;
    style?: React.CSSProperties;
    onRowClick?: (id: number | string) => void;
    onPageChange?: (id: number) => void;
}

const Table: React.StatelessComponent<ITableProps> = (props) => {
    const table = (
        <table style={props.style}>
            <TableHeader isLoading={props.isLoading} columns={props.tableConfig.columns} />
            <TableBody
                isLoading={props.isLoading}
                rowCount={props.tableConfig.rowCount}
                columns={props.tableConfig.columns}
                data={props.data ? props.data.items : []}
                idField={props.tableConfig.idField}
                onRowClick={props.onRowClick}
            />
        </table>
    );

    if (props.enablePaging) {
        if (props.data) {
            // const pageCount = Math.ceil(props.data.totalRecords / props.data.pageSize);

            return (
                <>
                    {table}
                    <Pager
                        pageSize={props.data.pageSize}
                        pageNumber={props.data.pageNumber}
                        currentPageCount={props.data.items.length}
                        totalRecords={props.data.totalRecords}
                        onPageChange={props.onPageChange}
                    />
                </>
            );
        } else {
            return (
                <>
                    {table}
                    <div>...</div>
                </>
            );
        }
    } else {
        return table;
    }
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/common/table/Table.tsx